import { useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "buzas-lgpd-consent";

export default function CookieBanner() {
  const [choice, setChoice] = useState(() =>
    window.localStorage.getItem(STORAGE_KEY),
  );

  if (choice) return null;

  const decide = (value) => {
    window.localStorage.setItem(STORAGE_KEY, value);
    setChoice(value);
  };

  return (
    <div
      role="region"
      aria-label="Aviso de privacidade"
      data-testid="lgpd-banner"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-white/10 bg-[color:var(--buzas-blue-ink)] text-white shadow-[0_-8px_24px_rgba(15,30,77,0.25)]"
    >
      {/* O espaço à direita reserva a área do botão flutuante de WhatsApp */}
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-8 sm:px-6 sm:pr-28 lg:px-8 lg:pr-28">
        <p className="text-sm leading-relaxed text-white/80">
          Usamos cookies e armazenamento local para o funcionamento do site e
          para melhorar sua experiência. Você pode aceitar ou recusar os
          cookies não essenciais. Saiba mais na nossa{" "}
          <Link
            to="/politica-de-privacidade"
            data-testid="lgpd-banner-policy-link"
            className="font-semibold text-white underline underline-offset-4 hover:text-white/80"
          >
            Política de Privacidade
          </Link>
          .
        </p>
        <div className="flex h-14 shrink-0 items-center gap-3 pr-20 sm:h-auto sm:pr-0">
          <button
            type="button"
            onClick={() => decide("rejected")}
            data-testid="lgpd-banner-reject"
            className="rounded-sm border border-white/40 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/10"
          >
            Recusar
          </button>
          <button
            type="button"
            onClick={() => decide("accepted")}
            data-testid="lgpd-banner-accept"
            className="rounded-sm bg-white px-5 py-2.5 text-sm font-semibold text-[color:var(--buzas-blue-ink)] transition-colors hover:bg-slate-100"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
